/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const Currency = styled.h3`
  font-size: 30px;
  padding-left: 10px;
  @media (max-width: 480px) {
    text-align: center;
  }
`;

export const Subtitle = styled.h5`
  padding-left: 6%;
  @media (max-width: 480px) {
    text-align: center;
  }
`;
